import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator' ;


@Component
class DeleteDialog extends Vue {

    @Prop({ default: '', type: [String] })
    message: string
    @Prop({ default: false, type: [Boolean] })
    isLoading: boolean

    readonly dtIsOpen: boolean= true

    get lblSetting() {
        return {
            ...require('@/locales/button').default
        }
    }

    handleCancel(){
        this.$emit('cancel')
    }

    handleDelete(){
        this.$emit('delete')
    }
}

export default DeleteDialog


// WEBPACK FOOTER //
// ./src/components/delete-dialog/index.ts